import script from "./AccessListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessListModal.vue?vue&type=script&setup=true&lang=js"

import "./AccessListModal.vue?vue&type=style&index=0&id=0680e15c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0680e15c"]])

export default __exports__